import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { amazoneAccProcess } from "../../../../../services/marketPlaceConnection";
import Loading from "../Loading/Loading";
import ErrorPage from "../ErrorPage/ErrorPage";
import { useRazorpay } from "../../../../../context/RazorpayContext";
import AddonPreviewModal from "../../Razorpay/AddonPreviewModal";
import RazorpayModal from "../../Razorpay/RazorpayModal";

const AmazonCallback = () => {
  const [searchParams] = useSearchParams();
  const { handleAddOnInvoicePreview, addonInvoicePreviewData, razorpayModalData } = useRazorpay();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isPreviewLoading, seIsPreviewLoading] = useState(false);
  const afterPaymentSuccessNavigationUrl = '/marketplace-accounts';
  const onCancelPaymentNavigationUrl = '/marketplace-accounts';

  useEffect(() => {
    const auth_code = searchParams.get("spapi_oauth_code");
    const state = searchParams.get("state");
    const account_id = searchParams.get("selling_partner_id");

    if (auth_code && state && account_id) {
      const processAuth = async () => {
        setLoading(true);
        window.history.replaceState(null, "", "/");
        try {
          const res = await amazoneAccProcess({
            auth_code,
            state,
            account_id,
          });

          if (res?.data?.need_subscription) {
            seIsPreviewLoading(true);
            setLoading(false);
            localStorage.setItem("need_marketplace_account", false);
            await handleAddOnInvoicePreview(seIsPreviewLoading, res?.data?.id);
          } else if (res.success) {
            setLoading(false);
            localStorage.setItem("need_marketplace_account", false);
            navigate("/marketplace-accounts");
          } else {
            // setLoading(false);
            console.error("Amazon auth process failed", res);
          }
        } catch (err) {
          // setLoading(false);
          console.error("Error processing Amazon auth:", err);
        }
      };

      processAuth();
    } else {
      navigate("/marketplace-accounts");
    }
  }, [searchParams, navigate]);

  return (
    <>
      {addonInvoicePreviewData?.isOpenModal && <AddonPreviewModal onCancelPaymentNavigationUrl={onCancelPaymentNavigationUrl}/>}
      {razorpayModalData?.isRazorPayModal && (
        <RazorpayModal navigationUrl={afterPaymentSuccessNavigationUrl} />
      )}
      {loading && (
        <Loading
          image="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
          text="Connecting your Amazon account..."
        />
      )}
    </>
  );
};

export default AmazonCallback;
